import { prodapiAxiosClient } from "../api/prodApiClient";


const getPallet = (palletBarcode) => {
    return prodapiAxiosClient
    .get(`/api/v1/pallet/${palletBarcode}`)
}

const newPallet = () => {
    return prodapiAxiosClient
    .put("/api/v1/pallet/create/")
}

const addMasterpackToPallet = (palletBarcode, masterpackBarcode) => {
    return prodapiAxiosClient
    .put(`/api/v1/pallet/addMasterpackToPallet?palletBarcode=${palletBarcode}&masterpackBarcode=${masterpackBarcode}`)
}

const removeMasterpackFromPallet = (palletBarcode, masterpackBarcode) => {
    return prodapiAxiosClient
    .put(`/api/v1/pallet/removeMasterpackFromPallet?palletBarcode=${palletBarcode}&masterpackBarcode=${masterpackBarcode}`)
}

const updatePallet = (palletBarcode, data) => {
    return prodapiAxiosClient
    .put(`/api/v1/pallet/update/${palletBarcode}`, data)
}


const palletApi = { newPallet, addMasterpackToPallet, removeMasterpackFromPallet, updatePallet, getPallet}
export default palletApi;